<template>
  <v-dialog
    :value="dialog"
    @click:outside="closeDialog('accept')"
    width="800"
    v-if="current && current.validations"
  >
    <v-card v-if="current">
      <v-card-title
        >Validation d'un bon de commande ({{ current.orderId
        }}{{ current.creatorTla }})</v-card-title
      >
      <v-card-text>
        <div v-if="current.validations.filter((v) => !v.user).length">
          <div class="body-1">
            Une fois la validation soumise, ce bon de commande sera bloqué en
            écriture et passera au niveau de validation suivant.
          </div>
          <div class="body-1 mt-2">
            Un e-mail de demande de validation sera, par ailleurs, envoyé à la
            personne responsable ce niveau.
          </div>
          <div class="body-1 mt-2">
            Pour ce faire, merci de bien vouloir renseigner la personne
            représentant votre
            {{
              labels[
                current.validations.filter((v) => !v.user).length
                  ? current.validations.filter((v) => !v.user)[0].type
                  : "accepted"
              ].toLowerCase()
            }}.
          </div>
          <v-autocomplete
            v-model="selected"
            :items="managers"
            :search-input.sync="searchManagers"
            label="Rechercher d'une personne *"
            outlined
            dense
            @input="clearSearchManagers"
            no-data-text="Tapez le nom d'une personne..."
            class="mt-5"
          />
        </div>
        <div v-else>
            Il s'agit du dernier niveau de validation.
            En validant ce bon de commande, un mail de confirmation sera envoyé à son créateur.
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="submitValidation">Valider ce bon de commande</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import axios from "axios";
import _ from "lodash";

export default {
  data: () => ({
    searchManagers: null,
    managers: [],
    selected: "",
  }),
  methods: {
    ...mapActions("dialog", ["closeDialog"]),
    ...mapActions("validations", ["submitValidationAsync"]),
    submitValidation() {
      this.submitValidationAsync({
        _id: this.current.validations.find((v) => v.status === "pending")._id,
        validator: this.selected,
        next: this.current.validations.filter((v) => !v.user).length
          ? this.current.validations.filter((v) => !v.user)[0].type
          : "accepted",
        status: "complete",
      });
    },
    async queryPicker(v, key) {
      this.loading = true;
      const { data: contacts } = await axios({
        method: "get",
        url: `${process.env.VUE_APP_PEOPLEPICKER_URI}/search?s=${v}`,
        headers: {
          "x-api-key": process.env.VUE_APP_PEOPLEPICKER_KEY,
        },
      });
      contacts.map((c) =>
        this[key].push({
          text: `${c.firstname} ${c.lastname}`,
          value: c,
        })
      );
      this[key] = _.uniqBy(this[key], "value.username");
      this.loading = false;
    },
    clearSearchManagers() {
      this.searchManagers = null;
    },
  },
  computed: {
    ...mapState({
      current: (state) => state.orders.current,
      labels: (state) => state.orders.labels,
      dialog: (state) => state.dialog.accept.open,
    }),
  },
  watch: {
    searchManagers: _.debounce(function (val) {
      val && val !== this.selected && this.queryPicker(val, "managers");
    }, 300),
  },
};
</script>